import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { AlertSettings, StoreSettings } from '@/api/types';

export function useStoreSettings() {
  return useQuery({
    queryKey: ['settings', 'store'],
    queryFn: () => api.get<StoreSettings>('/api/store-settings'),
    staleTime: 60_000,
  });
}

export function useUpdateStoreSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<StoreSettings>) => api.put<StoreSettings>('/api/store-settings', patch),
    onSuccess: (data) => queryClient.setQueryData(['settings', 'store'], data),
  });
}

export function useAlertSettings() {
  return useQuery({
    queryKey: ['settings', 'alerts'],
    queryFn: () => api.get<AlertSettings>('/api/alert-settings'),
    staleTime: 60_000,
  });
}

export function useUpdateAlertSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<AlertSettings>) => api.put<AlertSettings>('/api/alert-settings', patch),
    onSuccess: (data) => queryClient.setQueryData(['settings', 'alerts'], data),
  });
}
